/**
 * Plugin: Instagram (Meta Graph API).
 * Implementa o ChannelPlugin contract.
 */

import React from 'react';
import { IconBrandInstagram } from '@tabler/icons-react';
import { CHANNEL_CATEGORIES } from '../../types';

import useStatus from './useStatus';
import Card from './Card';
import Detail from './Detail';
import ConnectFlow from './ConnectFlow';

const InstagramChannel = {
  id: 'instagram',
  name: 'Instagram',
  description: 'DMs via Meta Graph API.',
  icon: IconBrandInstagram,
  color: '#E4405F',
  gradient: 'linear-gradient(135deg, #E4405F 0%, #C13584 100%)',
  category: CHANNEL_CATEGORIES.MESSAGING,
  isAvailable: true,
  provider: 'instagram',
  conflictsWith: [],

  useStatus,

  renderCard: (agentId, context) => <Card agentId={agentId} context={context} />,
  renderDetail: (agentId, navigation, onAlertCTA) => (
    <Detail agentId={agentId} navigation={navigation} onAlertCTA={onAlertCTA} />
  ),
  renderConnectFlow: (agentId, onConnected, onCancel) => (
    <ConnectFlow agentId={agentId} onConnected={onConnected} onCancel={onCancel} />
  ),
};

export default InstagramChannel;
